import React, { useState } from "react";
import "./index.scss";

import { Menu } from "@assets/icons/Menu";
import { MobileMenu } from "../MobilMenu";

export const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <header className="headerAdmin">
      <div className="app-header">
        <button onClick={toggleModal} className="icon-btn">
          <Menu />
        </button>
      </div>
      <MobileMenu showModal={showModal} toggleModal={toggleModal} />
    </header>
  );
};
